<template>
  <v-row wrap>
    <div :class="!isMobile ? 'home-mobile' : 'home'">
      <v-btn v-if="!isMobile" tile color="#FF4500" text dark @click="home">
        <v-icon v-if="!isMobile" size="27px" left> mdi-home </v-icon>
        voltar
      </v-btn>
      <v-btn v-else tile color="#FF4500" text dark @click="home">
        <v-icon large left> mdi-home </v-icon>
        Voltar ao gugla
      </v-btn>
    </div>

    <v-col :cols="isMobile ? '12' : '12'" style="background-color: #f0f2f5">
      <v-container fill-height style="height: 100vh">
        <v-row wrap justify="center" align="center">
          <v-col cols="12" :md="isMobile ? '6' : '6'" xl="4" sm="6">
            <v-container fill-height fluid>
              <v-row wrap>
                <v-col cols="12" md="12">
                  <v-card elevation="2" :disabled="disabled" max-width="470">
                    <v-progress-linear height="4" v-show="loading" indeterminate color="#25D366"></v-progress-linear>
                    <v-card-title>
                      <v-img :src="require('../../assets/img/Logo-Empresas-830x354.png')"
                        max-width="180" max-height="180" alt="Gugla Empresas"
                        style="display: block; margin-left: auto; margin-right: auto" />
                    </v-card-title>
                    <v-card-subtitle style="margin-bottom: 10px; margin-top: 5px">
                      <p>Um código foi enviado para o WhatsApp <span style="font-weight: bold;">+258{{ telefonerecovery }}</span>, use-o para recuperar a conta.</p>
                      <p>
                        <span>Não recebi nenhum código
                          <span class="register" @click="resubmit()" style="color: #FF5414; font-weight: bold">Reenviar</span>
                        </span>
                      </p>
                    </v-card-subtitle>
                    <v-card-text>
                      <validation-provider v-slot="{ errors }" rules="required" name="Código de verificação">
                        <v-text-field outlined v-model="formData.code" label="Código de verificação"
                          :error-messages="errors" color="#25D366" />
                      </validation-provider>
                      <v-card-actions>
                        <v-btn rounded text small :to="{ name: 'candidate.login' }"
                          style="padding-inline: 19px; margin-left: -30px;">
                          <v-icon left small> mdi-arrow-left </v-icon>
                          Voltar
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="#25D366" dark small @click="validate()"
                          style="padding-inline: 19px; margin-right: -7px;">Verificar</v-btn>
                      </v-card-actions>
                    </v-card-text>

                    <p class="text-center" style="margin-top: 60px;">
                      <span>Ainda não tem conta?
                        <span class="register" @click="register" style="color: #FF5414; font-weight: bold">Registe-se.</span>
                      </span>
                    </p>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
    <loader />
  </v-row>
</template>

<script>
import Loader from "../loader/Loader.vue";
import Swal from "sweetalert2";
import axios from "axios";
import { url } from "../../services/server";
import { ValidationProvider, setInteractionMode, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} não pode estar vazio!",
});

export default {
  components: { Loader, ValidationProvider },

  props: {
    telefonerecovery: { required: true },
  },

  data() {
    return {
      loading: false,
      disabled: false,
      formData: { code: "" },
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndUp;
    },
  },

  created() {
    const linkTag = document.createElement("link");
    linkTag.setAttribute("rel", "canonical");
    linkTag.setAttribute("href", "https://empresas.gugla.co.mz/candidate/login");
    document.head.appendChild(linkTag);
  },

  mounted() {
    this.sendOtp();
  },

  methods: {
    sendOtp() {
      this.loading = true;
      this.disabled = true;
      this.$store.dispatch("loaderChange", true);

      axios.post(`${url}/api/recruiters/recruiter/send-otp-whatsapp`, { contacto: this.telefonerecovery })
        .then(() => {
          this.$store.dispatch("loaderChange", false);
          this.loading = false;
          this.disabled = false;
        })
        .catch(() => {
          this.$store.dispatch("loaderChange", false);
          this.loading = false;
          this.disabled = false;
          Swal.fire({
            title: 'Erro ao enviar código',
            text: 'Não foi possível enviar o código via WhatsApp. Tente mais tarde.',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#FF1744',
          });
        });
    },

    validate() {
      this.loading = true;
      this.disabled = true;

      axios.post(`${url}/api/recruiters/recruiter/verify-otp-whatsapp`, { contacto: this.telefonerecovery, code: this.formData.code })
        .then(res => {
          this.$store.dispatch('loginWithWhatsappOtp', { token: res.data.token, recruiter: res.data.recruiter })
            .then(() => {
              this.$store.dispatch("changeLoginDialog", false);
              this.$router.push({ name: "candidate.define.chagepassword" });
              this.loading = false;
              this.disabled = false;
            })
            .catch(error => {
              this.loading = false;
              this.disabled = false;
              console.log(error);
            });
        })
        .catch(() => {
          this.loading = false;
          this.disabled = false;
          Swal.fire({
            title: 'Código inválido',
            text: 'O código está incorreto ou expirou.',
            icon: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: '#FF1744',
          });
        });
    },

    resubmit() {
      this.sendOtp();
    },

    register() {
      this.$router.push({ name: "candidate.register" });
    },

    home() {
      this.$router.push({ name: "site.contents" });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@900&display=swap");

.register {
  cursor: pointer;
}

.home {
  position: absolute;
  top: 30px;
  left: 30px;
}

.home-mobile {
  position: absolute;
  top: 15px;
  left: 15px;
}
</style>
